import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    load(event) {
        event.preventDefault()

        fetch(this.element.href, {
            headers: {
                "Accept": "text/vnd.turbo-stream.html"
            }
        })
            .then(response => response.text())
            .then(html => Turbo.renderStreamMessage(html))
    }
}